import { Image } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

import { Box, Flex, Typography } from "components/common/index"
import { IS_NA } from "helpers/application"

const Table = styled.table`
  ${({ theme }) => `
    width: 140%;
    border-collapse: separate;
    border-spacing: 4px 0px;
    margin-top: 1em;
    margin-bottom: 1em;
    ${theme.mediaQueries.tablet`
        width: 100%;
        margin-top: 1em;
        margin-bottom: 1em;
`}
`}
`
const TableWrapper = styled(Box).attrs({
  overflow: { _: "auto", tablet: "hidden" },
})``

const ChartTableData = styled(Box).attrs((props) => ({
  as: "tr",
  fontSize: "0.9em",
  textAlign: "left",
  ...props,
}))``

const Td = styled(Box).attrs((props) => ({
  as: "td",
  fontSize: props.subtitle ? "13px" : "16px",
  fontWeight: props.subtitle ? "normal" : 300,
  ...props,
}))`
  padding-top: 4px;
  width: 30%;
`
const TdHeader = styled(Td)`
  border-bottom: 1px solid #ebe6e2;
  font-weight: normal;
  padding-bottom: 1em;
`
const Title = styled(Typography).attrs((props) => ({
  as: "h2",
  fontWeight: "normal",
  lineHeight: "1.2",
  mt: 3,
  textAlign: "center",
  variant: "h2",
  ...props,
}))``

const SubTitle = styled(Typography).attrs((props) => ({
  as: "p",
  fontSize: { _: "16px", tablet: "0.8em", widescreen: "16px" },
  fontWeight: "300",
  lineHeight: "1.5",
  mt: 1,
  textAlign: "left",
  variant: "body3",
  ...props,
}))``

const BangleSizing = () => {
  const is_na = IS_NA()

  const unit = is_na ? "mm/in." : "mm"
  const sizingData = [
    {
      circumference: is_na ? "190.5mm | 7.5 in." : "190.5mm",
      diameter: is_na ? "60.6mm | 2.39 in." : "60.6mm",
      size: "Small (S)",
    },
    {
      circumference: is_na ? "203.2mm | 8.0 in." : "203.2mm",
      diameter: is_na ? "64.7mm | 2.55 in." : "64.7mm",
      size: "Medium (M)",
    },
    {
      circumference: is_na ? "215.9mm | 8.5 in." : "215.9mm",
      diameter: is_na ? "68.7mm | 2.71 in." : "68.7mm",
      size: "Large (L)",
    },
  ]
  return (
    <Box contain lineHeight="copy" mb={1} pb={1}>
      <Box bg="primaryColors.oldlace" mb={1} textAlign="center">
        <Box px={{ _: 3, desktop: "6em" }}>
          <Typography
            as="h1"
            fontWeight="normal"
            mb={2}
            pt={5}
            textAlign="center"
            variant="h1"
          >
            Bangle Size Guide
          </Typography>
          <Flex
            flexDirection={{ _: "column", tablet: "row" }}
            justifyContent="space-evenly"
            mb={5}
            pl={{ desktop: 2 }}
          >
            <Box
              borderRight={{ tablet: "solid 1px #a6a6a6" }}
              px={{ tablet: 6 }}
              width={{ tablet: "50%", widescreen: "93%" }}
            >
              <Image
                alt="Diameter"
                height="300px"
                src={require("images/leefiori/icons/existing-bangle-desktop.svg")}
                width={{ _: "60%", tablet: "40%" }}
              />

              <Title mt={{ tablet: 3 }}>If you have an existing bangle</Title>
              <SubTitle mt={2}>
                1. Measure the diameter ({unit}) of a bangle that is the desired
                size
              </SubTitle>

              <SubTitle mb={{ _: 4, tablet: 0 }} mt={1}>
                2. Use the Bangle Sizing Chart to locate the size that best
                suits you
              </SubTitle>
            </Box>
            <Box
              mx={{ tablet: 5 }}
              width={{ tablet: "50%", widescreen: "94%" }}
            >
              <Image
                alt="Circumference"
                height="300px"
                src={require("images/leefiori/icons/bangle-measuring-desktop.svg")}
                width={{ _: "95%", tablet: "68%" }}
              />

              <Title>If not, measure the widest point of your hand</Title>
              <SubTitle mt={2} pl={{ tablet: 3 }}>
                1. Tuck your thumb in towards the palm of your hand and then
                wrap a piece of string or strip of paper around the widest part,
                marking the point at which the two ends meet
              </SubTitle>

              <SubTitle pl={{ tablet: 3 }}>
                2. Measure the string or paper from mark to mark to find your
                bangle circumference ({unit})
              </SubTitle>
              <SubTitle pb={2} pl={{ tablet: 3 }}>
                3. Use the Bangle Sizing Chart to locate the size that best
                suits you
              </SubTitle>
            </Box>
          </Flex>
        </Box>{" "}
        <Box
          bg="white"
          mb={3}
          mx={{ desktop: "6em" }}
          pt={{ tablet: 5 }}
          px="2em"
          width={{ desktop: "55%" }}
        >
          <Typography
            as="h2"
            fontSize="24px"
            fontWeight="normal"
            mb={{ desktop: "10px" }}
            pt={{ _: 2, tablet: 0 }}
            textAlign="left"
          >
            Bangle Sizing Chart
          </Typography>
          <TableWrapper>
            <Table>
              <thead>
                <ChartTableData>
                  <TdHeader>Bangle Size </TdHeader>
                  <TdHeader> Circumference</TdHeader>
                  <TdHeader>Diameter </TdHeader>
                </ChartTableData>
              </thead>
              <tbody>
                {sizingData.map((tr, i) => (
                  <ChartTableData key={i}>
                    <Td subtitle>{tr.size}</Td>
                    <Td>{tr.circumference}</Td>
                    <Td>{tr.diameter}</Td>
                  </ChartTableData>
                ))}
              </tbody>
            </Table>
          </TableWrapper>
        </Box>
        <Box pb={6} px={{ _: 3, desktop: "6em" }}>
          <Typography as="h2" textAlign="left" variant="h2">
            Note:
          </Typography>
          <SubTitle>
            Once you have determined your hand size, we recommend choosing the
            bangle size that is closest to that measurement without exceeding
            it. This way, your bangle will fit securely enough that it will not
            fall off on its own and have a loose, comfortable fit around your
            wrist.
          </SubTitle>
        </Box>
      </Box>
    </Box>
  )
}
export default BangleSizing
